import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const openDiscord = () => window.open('https://discord.gg/kteFmyZEDY', '_blank', 'noopener,noreferrer');

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-section footer-section--brand">
          <h3>PRO Hub</h3>
          <p>Community tools for Pokemon Revolution Online.<br />Not affiliated with PRO.</p>
        </div>

        <div className="footer-section">
          <h4>Tools</h4>
          <div className="footer-links">
            <button onClick={() => navigate('/pokedex')} className="footer-link">Pokédex</button>
            <button onClick={() => navigate('/damage-calculator')} className="footer-link">Damage Calc</button>
            <button onClick={() => navigate('/team-builder')} className="footer-link">Team Builder</button>
            <button onClick={() => navigate('/map')} className="footer-link">Spawn Map</button>
          </div>
        </div>

        <div className="footer-section">
          <h4>Info</h4>
          <div className="footer-links">
            <button onClick={() => navigate('/faq')} className="footer-link">FAQ</button>
            <button onClick={() => navigate('/impressum')} className="footer-link">Legal Notice</button>
            <button onClick={() => navigate('/privacy')} className="footer-link">Privacy & Cookies</button>
          </div>
        </div>

        <div className="footer-section">
          <h4>Community</h4>
          <div className="footer-links">
            <button onClick={openDiscord} className="footer-link footer-link--discord">
              Discord Server ↗
            </button>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 PRO Hub — Community project for Pokemon Revolution Online. Not affiliated with Pokemon Revolution Online.</p>
      </div>
    </footer>
  );
};

export default Footer;
